import { render, staticRenderFns } from "./mobileAndSMSConfig.vue?vue&type=template&id=b2c2af1e&scoped=true"
import script from "./mobileAndSMSConfig.vue?vue&type=script&lang=js"
export * from "./mobileAndSMSConfig.vue?vue&type=script&lang=js"
import style0 from "./mobileAndSMSConfig.vue?vue&type=style&index=0&id=b2c2af1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c2af1e",
  null
  
)

export default component.exports